module.exports = __webpack_public_path__ + "img/bs3.8c759c79.png";